import { RootState } from '@src/store/store'
import { CouponsStateType } from '@src/store/ducks/coupons/reducer'

export const selectCoupons = (state: RootState): CouponsStateType => state.coupons

export const selectCouponsList = (state: RootState) => selectCoupons(state).coupons
export const selectCouponsIsNext = (state: RootState) => selectCoupons(state).isNext
export const selectCouponsTotal = (state: RootState) => selectCoupons(state).total
export const selectCouponsIsLoading = (state: RootState) => selectCoupons(state).isLoading
